function startDailyDealCountdown() {
    const countdownEls = document.querySelectorAll('.daily-deal-countdown');

    function getESTNow() {
      const now = new Date();
      const est = new Date(
        now.toLocaleString("en-US", { timeZone: "America/New_York" })
      );
      return est;
    }

    function decodeHTML(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    }

    countdownEls.forEach((el) => {
      const dealTimeStr = el.dataset.dealTime;
      let template = decodeHTML(el.dataset.template);

      if (!dealTimeStr || !/^\d{2}:\d{2}$/.test(dealTimeStr)) return;

      const [dealHour, dealMinute] = dealTimeStr.split(":").map(Number);

      function updateCountdown() {
        const now = getESTNow();

        let dealDate = new Date(now);
        dealDate.setHours(dealHour, dealMinute, 0, 0);

        if (dealDate < now) {
          dealDate.setDate(dealDate.getDate() + 1);
        }

        const diffMs = dealDate - now;
        const totalSeconds = Math.floor(diffMs / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const renderedHTML = template
          .replace(/HH/g, String(hours).padStart(2, "0"))
          .replace(/MM/g, String(minutes).padStart(2, "0"))
          .replace(/SS/g, String(seconds).padStart(2, "0"));

        el.innerHTML = renderedHTML;
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  }

document.addEventListener("DOMContentLoaded", startDailyDealCountdown);

  document.addEventListener("DOMContentLoaded", function() {
  const faqQuestions = document.querySelectorAll(".faq-question");

  faqQuestions.forEach(button => {
    button.addEventListener("click", () => {
      const answer = button.nextElementSibling;
      const expanded = button.getAttribute("aria-expanded") === "true";

      // Collapse all first
      document.querySelectorAll(".faq-question").forEach(btn => {
        btn.setAttribute("aria-expanded", "false");
        btn.nextElementSibling.classList.remove("active");
      });

      // Expand the clicked one if it was previously closed
      if (!expanded) {
        button.setAttribute("aria-expanded", "true");
        answer.classList.add("active");
      }
    });
  });
});
